import React, { useState, useEffect, Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ReactTooltip from "react-tooltip";
import {
  makeStyles,
  Divider,
} from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import { AxiosGetJson, AxiosPostJson } from "src/Service/Config/AxiosMethod";
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import axios from "axios"
import qs from "qs";

import { useHistory } from "react-router";
import InfiniteScroll from "react-infinite-scroll-component";
import { IsNullOrUndefined } from "src/Service/CommonFunction/TS_function";

const useStyles = makeStyles((theme) => ({
  dropdown: {
    borderRadius: "3px",
    // overflow:'auto',
    width: '360px',
    // height:'200px',
    border: "0",
    boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.26)",
    top: "100%",
    zIndex: 1000,
    minWidth: "160px",
    padding: "5px 0",
    margin: "2px 0 0",
    fontSize: "14px",
    textAlign: "left",
    listStyle: "none",
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
  },
  menuList: {
    padding: 0,
  },
  popperResponsive: {
    zIndex: 1200,
    [theme.breakpoints.down("sm")]: {
      zIndex: 1640,
      position: "static",
      float: "none",
      width: "auto",
      marginTop: "0",
      backgroundColor: "transparent",
      border: "0",
      boxShadow: "none",
      color: "black",
    },
  },
  dropdownItem: {
    fontSize: "13px",
    padding: "10px 20px",
    margin: "0 5px",
    borderRadius: "2px",
    position: "relative",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: 400,
    height: "fit-content",
    color: "#333",
    whiteSpace: "nowrap",
    minHeight: "unset",
  },
  dropdownDividerItem: {
    margin: "5px 0",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    height: "1px",
    overflow: "hidden",
  },
  sidebarItemtext: {
    width: "100%",
    color: '#757575'
  },
  dropdownHeader: {
    display: "block",
    padding: "0.1875rem 1.25rem",
    fontSize: "0.75rem",
    lineHeight: "1.428571",
    color: "#777",
    whiteSpace: "nowrap",
    fontWeight: "inherit",
    marginTop: "10px",
    minHeight: "unset",
    "&:hover,&:focus": {
      backgroundColor: "transparent",
      cursor: "auto",
    },
  },
}));

const Notification = () => {
  const history = useHistory();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null as any);
  const [lstNotification, setlstNotification] = useState([] as any);
  const [page, setPage] = useState(1)
  const [More, setMore] = useState(true)
  const [nlength, setnlength] = useState(0)
  const [notRead, setnotRead] = useState(0)
  const [nStart, setnStart] = useState(10)

  useEffect(() => {
    GetNotifications(nStart);
  }, []);

  const GetNotifications = async (nlength) => {
    var data = { length: nlength };
    let result = await AxiosGetJson("Home/GetNotifications", data);

    if (result) {
        setlstNotification(result.lstnotification || [])
        setnlength(result.allNotification)
        setnotRead(result.NotReadNotification)
    }
  }
  const ReadNoti = async (nNotification, link) => {
    let obj = { ID: nNotification }
    let resule: any = await AxiosPostJson("Home/ReadNotification", obj)
    window.location.href = link; //one level up
  }

  const handleClick = (event) => {
    if (anchorEl && anchorEl.contains(event.target)) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
    // ReadNoti()
  };

  const handleCloseAway = (event) => {
    if (anchorEl.contains(event.target)) {
      return;
    }
    setAnchorEl(null);
  };

  const fetchMoreData = async () => {
    let startIndex = lstNotification.length > 0 ? lstNotification.length : nStart;
    for (let i = startIndex; i <= nlength+5; i = i + 5) {
      await GetNotifications(i);
      if (i >= nlength) {
        setMore(false)
        break;
      }
    }
  }

  return (
    <Fragment>
      <IconButton onClick={handleClick}>
        <Badge badgeContent={notRead} color="secondary">
          <NotificationsIcon style={{ color: "#bdbdbd" }} />
        </Badge>
      </IconButton>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement={"bottom-end"}
      >
        {() => (
          <Grow
            in={Boolean(anchorEl)}
            style={{ transformOrigin: "0 0 0" }}
          >
            <Paper className={classes.dropdown}>
              <ClickAwayListener onClickAway={handleCloseAway}>
                <MenuList role="menu" className={classes.menuList}>
                  <MenuItem
                    className={classes.dropdownHeader}
                  >
                    Notifications
                  </MenuItem>
                  <Divider style={{ width: '100%' }} />
                  <InfiniteScroll
                    // initialScrollY={3} 
                    height={280}
                    dataLength={lstNotification.length}
                    hasMore={More}
                    next={() => { fetchMoreData() }}
                    loader={
                      <div style={{ textAlign: 'center' }}>
                        {lstNotification.length > 0 ?
                          <p>Loading...</p>
                          :
                          <p>No notification</p>}
                      </div>}

                  >
                    {lstNotification.map((item, key) => {
                      return (
                        <Tooltip
                          title={
                            <React.Fragment>
                              <Typography style={{ fontSize: '14px' }}>{item.sMessage}</Typography>{' '}
                              <Typography style={{ fontSize: '14px' }}>{(item.sRemark + "").length > 0 && item.sRemark != null ? "Remark : " + item.sRemark : ""}</Typography>
                            </React.Fragment>
                          }
                          placement="left" arrow={true}>

                          <div key={key} onClick={() => { ReadNoti(item.nNotificationID, item.sLinkUrl) }}>
                            <MenuItem
                              key={key}
                              className={classes.dropdownItem}
                              data-tip data-for="Item"
                            >
                              {item.IsReaded ?
                                (item.sMessage + "").length > 45 ?
                                  (item.sMessage + "").substring(0, 45) + "..."
                                  :
                                  item.sMessage
                                :
                                <b>
                                  <FiberManualRecordIcon style={{ fontSize: '8px', color: '#00aeef' }} />
                                  &nbsp;&nbsp;
                                  {(item.sMessage + "").length > 45 ?
                                    (item.sMessage + "").substring(0, 45) + "..."
                                    :
                                    item.sMessage}
                                </b>}
                            </MenuItem>
                          </div>
                        </Tooltip>

                      );
                    })}
                  </InfiniteScroll>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};
export default Notification;
